export default class PriceOption {
    constructor(portionSize, price) {
        this.portionSize = portionSize;
        this.price = price
    }
}